export function initCookiebot(cbid: string): void {
	if (document.getElementById('Cookiebot')) {
		console.warn(`Cookiebot déjà initialisé avec l'ID ${cbid}`);
		return;
	}

	const cookiebotScript: HTMLScriptElement = document.createElement('script');
	cookiebotScript.id = 'Cookiebot';
	cookiebotScript.src = 'https://consent.cookiebot.com/uc.js';
	cookiebotScript.async = true;
	cookiebotScript.setAttribute('data-cbid', cbid);
	cookiebotScript.setAttribute('data-blockingmode', 'auto');

	// Cookiebot doit être chargé le plus tôt possible pour bloquer les autres scripts
	document.head.insertBefore(cookiebotScript, document.head.firstChild);

	console.info(`Cookiebot initialisé avec l'ID ${cbid}`);
}
